<script>
import dayjs from '@/services/date'
import DateFormatToken from '@/shared/constants/date/DateFormatToken'
import UserAvatar from '@/components/user/user-avatar.vue'
import CandidateStatItem from './candidate-stat-item.vue'

export default {
  name: 'CandidateDetailsHeader',
  components: { UserAvatar, CandidateStatItem },
  props: {
    candidate: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    profilePicture: {
      type: String,
      default: null,
    },
  },
  computed: {
    candidateName() {
      if (!this.candidate) return null

      const {
        preferredFirstName,
        firstName,
        lastName,
        fullName,
      } = this.candidate

      const first = preferredFirstName || firstName
      const full = fullName || null

      const name = first && lastName ? `${first} ${lastName}` : full

      return name.toLowerCase()
    },
    numberOfBookings() {
      return this.candidate?.numberOfBookings ?? 0
    },
    lastWorked() {
      const date = this.candidate?.mostRecentBookingDateUTC
      if (!date) return this.$t('candidateDetailsPopup.header.neverWorked')

      const dateTz = dayjs(date).tz(this.candidate.timeZone)

      return this.$t('candidateDetailsPopup.header.lastWorked', {
        relativeDate: dayjs().to(dateTz),
      })
    },
    joinedYear() {
      const date = this.candidate?.dateHiredUTC
      if (!date) return null
      return this.$t('candidateDetailsPopup.header.joined', {
        year: dayjs(date).format(DateFormatToken.YYYY),
      })
    },
  },
}
</script>

<template>
  <div class="candidate-details-header d-flex flex-rows">
    <UserAvatar
      transparent-outline
      :name="candidateName || ' '"
      :image-url="profilePicture"
      size="120"
      class="mr-4"
    />

    <div class="candidate-details-header__info-container">
      <!-- Name -->
      <div v-if="isLoading" class="mb-2">
        <v-skeleton-loader
          loading
          style="width: 200px; height: 28px;"
          type="image"
        />
      </div>
      <div v-else class="display-md mb-2 text-capitalize">
        {{ candidateName || '' }}
      </div>

      <!-- Stats row -->
      <div class="d-flex flex-wrap mb-2">
        <!-- Bookings -->
        <CandidateStatItem
          :is-loading="isLoading"
          icon="mdi-book-open-page-variant-outline"
          class="align-center mr-3"
        >
          {{
            $tc('candidateDetailsPopup.header.bookings', numberOfBookings, {
              numBookings: numberOfBookings,
            })
          }}
        </CandidateStatItem>

        <!-- Last worked -->
        <CandidateStatItem
          :is-loading="isLoading"
          icon="mdi-calendar-month-outline"
          skeleton-width="80px"
          class="align-center"
        >
          {{ lastWorked }}
        </CandidateStatItem>
      </div>
      <!-- Joined year -->
      <CandidateStatItem v-if="joinedYear" :is-loading="isLoading">
        {{ joinedYear }}
      </CandidateStatItem>
    </div>
  </div>
</template>
